import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SharedFooter from '../components/SharedFooter';
import { ChevronLeft, Phone, Mail, MapPin, Menu, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RegulaminPage = () => {
  const [content, setContent] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/site-content`);
      setContent(response.data);
    } catch (error) {
      console.error('Error fetching content:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const logoUrl = content.site_logo || "https://customer-assets.emergentagent.com/job_rustic-retreat-7/artifacts/gtmkak5t_5556a.png";

  const navLinks = [
    { name: 'O nas', href: '/#about' },
    { name: 'Oferta', href: '/#offer' },
    { name: 'Galeria', href: '/#gallery' },
    { name: 'Balia Basen Sauna', href: '/spa', isRoute: true },
    { name: 'W okolicy', href: '/#attractions' },
    { name: 'Kontakt', href: '/#contact' },
    { name: 'Regulamin', href: '/regulamin', isRoute: true, active: true },
  ];

  if (isLoading) {
    return (
      <div className="min-h-screen bg-sand flex items-center justify-center">
        <div className="animate-pulse font-heading text-2xl text-forest">Ładowanie...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-sand" data-testid="regulamin-page">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-soft">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center gap-3">
              <img src={logoUrl} alt="VIP Village Logo" className="h-24 md:h-28 w-auto object-contain" />
              <div className="text-forest">
                <span className="font-heading text-xl font-semibold">VIP VILLAGE</span>
                <p className="text-xs font-body opacity-80">Las • Woda • Rower</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-6">
              {navLinks.map((link) => (
                link.isRoute ? (
                  <Link
                    key={link.name}
                    to={link.href}
                    className={`font-body text-sm tracking-wide transition-colors duration-300 hover:text-terracotta ${
                      link.active ? 'text-terracotta' : 'text-forest'
                    }`}
                  >
                    {link.name}
                  </Link>
                ) : (
                  <a key={link.name} href={link.href} className="font-body text-sm text-forest hover:text-terracotta transition-colors">
                    {link.name}
                  </a>
                )
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button className="lg:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              {mobileMenuOpen ? <X className="text-forest" /> : <Menu className="text-forest" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t">
            <div className="px-4 py-4 space-y-3">
              {navLinks.map((link) => (
                link.isRoute ? (
                  <Link key={link.name} to={link.href} className="block font-body text-forest py-2" onClick={() => setMobileMenuOpen(false)}>
                    {link.name}
                  </Link>
                ) : (
                  <a key={link.name} href={link.href} className="block font-body text-forest py-2" onClick={() => setMobileMenuOpen(false)}>
                    {link.name}
                  </a>
                )
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* Content */}
      <main className="pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <Link to="/" className="inline-flex items-center gap-2 text-forest/70 hover:text-forest mb-6 transition">
            <ChevronLeft className="w-4 h-4" /> Powrót do strony głównej
          </Link>
          
          <h1 className="font-heading text-4xl md:text-5xl text-forest mb-8">Regulamin</h1>
          
          <div 
            className="prose prose-lg max-w-none font-body text-forest/80
              prose-headings:font-heading prose-headings:text-forest
              prose-h3:text-xl prose-h3:mt-8 prose-h3:mb-4
              prose-p:leading-relaxed prose-p:mb-4
              prose-ul:my-4 prose-ul:list-disc prose-ul:pl-6
              prose-ol:my-4 prose-ol:list-decimal prose-ol:pl-6
              prose-li:my-2 prose-li:pl-2"
            dangerouslySetInnerHTML={{ __html: content.regulamin || '<p>Treść regulaminu...</p>' }}
          />
        </div>
      </main>

      <SharedFooter content={content} />
    </div>
  );
};

export default RegulaminPage;
